var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLockIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("span", {
  className: "icon"
}, /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 21,
  fill: "none",
  viewBox: "0 0 17 21",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.98 6.201V5.197A5.025 5.025 0 0 0 8.96.177a5.025 5.025 0 0 0-5.019 5.02V8.21H2.937A2.01 2.01 0 0 0 .93 10.217v8.03c0 1.108.9 2.009 2.007 2.009h12.047a2.01 2.01 0 0 0 2.008-2.008v-8.031a2.01 2.01 0 0 0-2.008-2.008H5.95V5.197a3.015 3.015 0 0 1 3.012-3.011 3.015 3.015 0 0 1 3.012 3.011v1.004z"
}))));
export { SvgLockIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/lockIcon.svg";